export const apiUrls = {
    // Dashboard
    getDashboardDetails: () => `dashboard/details`,
    // User
    getUsers: () => `user`,
    getUser: (id) => `user/${id}`,
    addUser: () => `user`,
    updateUser: (id) => `user/${id}`,
    deleteUser: (id) => `user/${id}`,
    authenticateUser:() => `auth/login`,
    // Customer
    getCustomers: () => `customer`,
    getCustomer: (id) => `customer/${id}`,
    addCustomer: () => `customer`,
    updateCustomer: (id) => `customer/${id}`,
    deleteCustomer: (id) => `customer/${id}`,
    getAllCustomers: () => `customer/lookup`,
    getCustomerDetails: (id) => `customer/${id}/details`,
    getCustomerInvoices: (id) => `customer/${id}/invoices`,
    deleteCustomerInvoice: (id) => `customer/${id}/invoices`,
    // Invoice
    getInvoices: () => `invoice`,
    getInvoice: (id) => `invoice/${id}`,
    addInvoice: () => `invoice`,
    updateInvoice: (id) => `invoice/${id}`,
    deleteInvoice: (id) => `invoice/${id}`,
    getInvoiceDetails: (id) => `invoice/${id}/details`,
    completeInvoice: (id) => `invoice/${id}/complete`,
    downloadInvoice: (id) => `invoice/${id}/download`,    
    paymentInvoice: (id) => `invoice/${id}/payment`,
    getInvoiceItems: () => `invoice/item`,
    getInvoiceItem: (id) => `invoice/item/${id}`,
    addInvoiceItem: () => `invoice/item`,
    updateInvoiceItem: (id) => `invoice/item/${id}`,
    deleteInvoiceItem: (id) => `invoice/item/${id}`,
}
